// @flow

const MEDIA_TYPES = {
	IMAGES: "images",
	VIDEOS: "videos",
};

const SIZE_TYPES = {
	vector_eps: { name: "vector" },
	// IMAGES
	small_jpg: { name: "small", type: MEDIA_TYPES.IMAGES },
	medium_jpg: { name: "medium", type: MEDIA_TYPES.IMAGES },
	huge_jpg: { name: "huge", type: MEDIA_TYPES.IMAGES },
	// VIDEOS
	web: { type: MEDIA_TYPES.VIDEOS },
	sd: { type: MEDIA_TYPES.VIDEOS },
	hd: { type: MEDIA_TYPES.VIDEOS },
	"4k": { type: MEDIA_TYPES.VIDEOS },
};

export default {
	ROUTES: {
		SEARCH: "search",
		PURCHASE: "purchase",
	},

	CONTEXTS: {
		SEARCH: 1,
	},

	MEDIA_TYPES,

	DEFAULT_NUMBER_OF_PEOPLE: 1,

	SORT_OPTIONS: ["popular", "newest", "relevance", "random"],

	VIDEO_DURATION: {
		SHORT: 240, // 4 * 60,
		LONG: 1200, // 20 * 60,
	},

	MAX_RESULTS: {
		SELECTION: 4,
		SEARCH: 20,
	},

	FORMATS_MAP: {
		vector: "eps",
		medium: "jpg",
		huge: "jpg",
		small: "jpg",
		hd: "mp4",
		"4k": "mp4",
		sd: "mp4",
		web: "mp4",
	},

	SIZE_TYPES,

	DEFAULT_SIZE_ORDER: ["vector_eps", "medium_jpg", "huge_jpg", "small_jpg", "web", "sd", "hd", "4k"],

	TOKEN_TTL_MINUTES: 60, // 1 hour

	COLORS: [
		{ label: "shutterstock.filters.colors.red", value: "#E72525" },
		{ label: "shutterstock.filters.colors.orange", value: "#F48700" },
		{ label: "shutterstock.filters.colors.amber", value: "#ECA71D", darkCheck: true },
		{ label: "shutterstock.filters.colors.yellow", value: "#F1F129", darkCheck: true },
		{ label: "shutterstock.filters.colors.lime", value: "#A9E418", darkCheck: true },
		{ label: "shutterstock.filters.colors.green", value: "#06D506" },
		{ label: "shutterstock.filters.colors.teal", value: "#0ECB9B" },
		{ label: "shutterstock.filters.colors.turquoise", value: "#1AE0E0", darkCheck: true },
		{ label: "shutterstock.filters.colors.aqua", value: "#0BBBF5" },
		{ label: "shutterstock.filters.colors.azure", value: "#1F55F8" },
		{ label: "shutterstock.filters.colors.blue", value: "#00F" },
		{ label: "shutterstock.filters.colors.purple", value: "#7F00FF" },
		{ label: "shutterstock.filters.colors.orchid", value: "#BF00FF" },
		{ label: "shutterstock.filters.colors.magenta", value: "#EA06B1" },
	],
};
